
export default () => /Mobi|Android/i.test(navigator.userAgent) || window.innerWidth < 915
